// Poll the DOM until `selector` appears (and, by default, is visible), then run
// onFound(el); give up after `tries`. Returns a cancel() that stops the poll.
// Replaces the hand-rolled setInterval/tries/clearInterval loop the guide
// triggers each repeated.
//
//   requireVisible  el.offsetParent !== null (skip for buttons that just need
//                   to exist, e.g. #nextPageBtn / #favLoadBtn).
export function waitForElement(
  selector,
  { onFound, onTimeout, tries = 40, interval = 500, requireVisible = true } = {}
) {
  let n = 0;
  const id = setInterval(() => {
    n += 1;
    const el = document.querySelector(selector);
    if (el && (!requireVisible || el.offsetParent !== null)) {
      clearInterval(id);
      if (onFound) onFound(el);
    } else if (n >= tries) {
      clearInterval(id);
      if (onTimeout) onTimeout();
    }
  }, interval);
  return () => clearInterval(id);
}

export const suppressAzPopup = () =>
  sessionStorage.setItem("nepeto_suppress_azpopup", "1");

export const clearAzPopup = () =>
  sessionStorage.removeItem("nepeto_suppress_azpopup");
